import Result from "@/core/common/Result";
import {
  IgnorarPesquisaParams,
  IIgnorarPesquisaCSATUseCase
} from "../ports/IgnorarPesquisaCSATUseCase";
import { inject, injectable } from "inversify";
import "reflect-metadata";
import { SalvarAvaliacaoCSATMinhasEmpresasGateway } from "./SalvarAvaliacaoCSATMinhasEmpresasGateway";

@injectable()
export class IgnorarPesquisaCSATUseCaseAdapter
  implements IIgnorarPesquisaCSATUseCase
{
  @inject(SalvarAvaliacaoCSATMinhasEmpresasGateway)
  private readonly salvarAvaliacaoMinhasEmpresasGateway!: SalvarAvaliacaoCSATMinhasEmpresasGateway;

  async ignorarPesquisa(params: IgnorarPesquisaParams): Promise<Result<void>> {
    const response = await this.salvarAvaliacaoMinhasEmpresasGateway.salvar({
      pesquisaCSATId: params.pesquisaId,
      nota: 0,
      comentario: undefined
    });

    if (response.isFailure) return Result.fail(response.error);

    return Result.ok();
  }
}
